import { render, staticRenderFns } from "./addTeachLesson.vue?vue&type=template&id=a49edbdc&scoped=true"
import script from "./addTeachLesson.vue?vue&type=script&lang=ts"
export * from "./addTeachLesson.vue?vue&type=script&lang=ts"
import style0 from "./addTeachLesson.vue?vue&type=style&index=0&id=a49edbdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49edbdc",
  null
  
)

export default component.exports